import {
  type AdminProductResponseItem,
  AdminProductResponseItemSchema,
  AdminProductsResponseSchema,
  type AdminUserResponseItem,
  AdminUserResponseItemSchema,
  AdminUsersResponseSchema,
  type ClaimsResponse,
  ClaimsResponseSchema,
  type GenerateProductListResponse,
  GenerateProductListResponseSchema,
  type GenerateSvgDrawingResponse,
  GenerateSvgDrawingResponseSchema,
  type ServicePricesResponse,
  ServicePricesResponseSchema
} from './types'

/**
 * Map response of 'api/admin/products' (GET).
 * @param res response payload.
 */
export function mapAdminProductsResponse(res: unknown): AdminProductResponseItem[] {
  return AdminProductsResponseSchema.parse(res)
}

/**
 * Map response of e.g. 'api/admin/products' (POST).
 * @param res response payload.
 */
export function mapAdminProductResponse(res: unknown): AdminProductResponseItem {
  return AdminProductResponseItemSchema.parse(res)
}

/**
 * Map response of 'api/admin/authorized-users' (GET).
 * @param res response payload.
 */
export function mapAdminUsersResponse(res: unknown): AdminUserResponseItem[] {
  return AdminUsersResponseSchema.parse(res)
}

/**
 * Map response of e.g. 'api/admin/users' (POST/PUT).
 * @param res response payload.
 */
export function mapAdminUserResponse(res: unknown): AdminUserResponseItem {
  return AdminUserResponseItemSchema.parse(res)
}

/**
 * Map response of 'api/auth/claims'.
 * @param res response payload.
 */
export function mapClaimsResponse(res: unknown): ClaimsResponse {
  return ClaimsResponseSchema.parse(res)
}

/**
 * Nao response of 'api/planner/product-list'.
 * @param res response payload.
 */
export function mapGenerateProductListResponse(res: unknown): GenerateProductListResponse {
  return GenerateProductListResponseSchema.parse(res)
}

/**
 * Nao response of 'api/planner/drawing'.
 * @param res response payload.
 */
export function mapDrawingResponse(res: unknown): GenerateSvgDrawingResponse {
  return GenerateSvgDrawingResponseSchema.parse(res)
}

/**
 * Nao response of 'api/planner/service-prices'.
 * @param res response payload.
 */
export function mapServicePricesResponse(res: unknown): ServicePricesResponse {
  return ServicePricesResponseSchema.parse(res)
}
